export default __webpack_public_path__ + "static/media/no_product.f84bdab9.png";